import { Card, DatePicker, Form, Input, Select } from "antd";
import React, { useEffect, useState } from "react";
import {
  updateDoc,
  doc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { db, auth } from "../../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { toast } from "react-hot-toast";
import { states } from "../../../../utils/Util";
import FormAction from "../../../../components/common/FormAction";

import "./Screening.css";

function Screening({ data }) {
  const [checked, setChecked] = useState(false);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));
      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const onCancel = () => {
    setChecked(false);
  };

  const handleFormSubmit = (values) => {
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });
    const status = {
        "screening.dateOfBirth": values.dateOfBirth
          ? values.dateOfBirth.format("YYYY-MM-DD")
          : data?.screening?.dateOfBirth,
        "screening.ssn": values.ssn,
        "screening.driverLicense": values.number,
        "screening.state": values.state,
        "screening.creditReportDate": values.creditScoreDate
          ? values.creditScoreDate.format("YYYY-MM-DD")
          : data?.screening?.creditReportDate,
        "screening.creditScore": values.creditScore,
    };
    try {
      const tenantRef = doc(
        db,
        "companies",
        companyName,
        "tenants",
        data?.id
      );
      updateDoc(tenantRef, status);
      setChecked(false);
      toast.success("Tenenat screening updated successfully");
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  const initialValues = {
    ssn: data?.screening?.ssn,
    licenseNumber: data?.screening?.licenseNumber,
    state: data?.screening?.state,
    creditScore: data?.screening?.creditScore,
  };
  return (
    <Card
      title="Screening"
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
    >
      {checked ? (
        <Form
          colon={false}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 11 }}
          labelWrap={{ span: 8 }}
          className="screening"
          initialValues={initialValues}
          onFinish={handleFormSubmit}
          onFinishFailed={onFinishFailed}
        >
          <Form.Item label="Date Of Birth" name="dateOfBirth">
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="SSN" name="ssn">
            <Input />
          </Form.Item>
          <Form.Item label="Drivers License">
            <div className="number-container">
              <Form.Item name="number">
                <Input placeholder="Number" />
              </Form.Item>
              <Form.Item name="state">
                <Select options={states} placeholder="Select..." />
              </Form.Item>
            </div>
          </Form.Item>
          <Form.Item label="Credit Report Date" name="creditScoreDate">
            <DatePicker style={{ width: "100%" }} />
          </Form.Item>
          <Form.Item label="Credit Score" name="creditScore">
            <Input />
          </Form.Item>
          <FormAction cancel={onCancel} submit="submit" />
        </Form>
      ) : null}
    </Card>
  );
}

export default Screening;
